import * as React from 'react'
import classNames from 'classnames'
import dynamic from 'next/dynamic'

import {useScrollInfo} from '@lib/hooks'
import {t} from '@lib/helpers'

const Hamburger = dynamic(() => import('@components/Hamburger'))

const Header = ({name}) => {
  const [showMenu, setShowMenu] = React.useState(false)
  const {currentScrollPos, direction} = useScrollInfo()

  React.useEffect(() => {
    if (direction === 'down') {
      setShowMenu(false)
    }
  }, [direction])

  const toggleMenu = () => setShowMenu((state) => !state)

  const goTop = (event) => {
    event.preventDefault()
    window.location.hash = ''
    document.body.scrollIntoView({behavior: 'smooth'})
  }

  const handleClick = (event) => {
    event.preventDefault()

    const {hash} = event.target

    window.history.pushState(null, null, hash)
    document.querySelector(hash).scrollIntoView({behavior: 'smooth'})
    setShowMenu(false)
  }

  return (
    <header
      className={classNames('DemoDetail__header', {
        'DemoDetail__header--hide':
          currentScrollPos > 0 && direction === 'down',
      })}
    >
      <div className='container'>
        <h1 className='DemoDetail__logo'>
          <a href='#' title={name} onClick={goTop}>
            {name}
          </a>
        </h1>

        <Hamburger
          klass='DemoDetail__toggle-menu'
          isActive={showMenu}
          isActiveSet={toggleMenu}
        />

        <nav
          className={classNames('DemoDetail__nav', {
            'DemoDetail__nav--show': showMenu,
          })}
        >
          <a
            href='#why'
            title={`${t('pages.demo.shared.nav.why')} ${name}`}
            onClick={handleClick}
          >
            {`${t('pages.demo.shared.nav.why')} ${name}`}
          </a>
          <a
            href='#contact'
            title={t('pages.demo.shared.nav.contact')}
            onClick={handleClick}
          >
            {t('pages.demo.shared.nav.contact')}
          </a>
          <a
            href='#upload'
            title={t('pages.demo.shared.nav.contact')}
            onClick={handleClick}
          >
            {t('pages.demo.shared.nav.upload_image')}
          </a>
        </nav>
      </div>
    </header>
  )
}

export default Header
